import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    TICKET_LIST_DATA: {}, CONTACT_LIST_DATA: {}
}

export const TICKET_LIST = createApiThunkPrivate('TICKET_LIST', '/support-tickets/ticket-list', 'GET', true)
export const UPDATE_STATUS = createApiThunkPrivate('UPDATE_STATUS', '/support-tickets/update-ticket-status', 'POST')
export const TICKET_CHATS = createApiThunkPrivate('TICKET_CHATS', '/support-tickets/ticket-chats', 'POST')


export const CONTACT_LIST = createApiThunkPrivate('CONTACT_LIST', '/contact-us/list', 'GET', true)


const supportSlice = createSlice({
    name: 'support-ticket',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, TICKET_LIST, 'TICKET_LIST_DATA')
        createExtraReducersForThunk(builder, UPDATE_STATUS, 'UPDATE_STATUS_DATA')
        createExtraReducersForThunk(builder, TICKET_CHATS, 'TICKET_CHATS_DATA')

        createExtraReducersForThunk(builder, CONTACT_LIST, 'CONTACT_LIST_DATA')

    }
})

export default supportSlice.reducer